import type { IntranetCategory } from '@gb-ticket/shared-types';

import {
  INTRANET_SIDEBAR_PREVIEW,
  previewItems,
} from '@/products/intranet/features/intranet/preview-list';

/** Rubrics shown before „Mehr anzeigen“ (the seventh opens the rest). */
export const INTRANET_CHANNEL_PREVIEW = INTRANET_SIDEBAR_PREVIEW;

export function filterIntranetChannels(
  categories: readonly IntranetCategory[],
  query: string,
): IntranetCategory[] {
  const needle = query.trim().toLocaleLowerCase('de-DE');
  if (!needle) {
    return [...categories];
  }
  return categories.filter((category) => category.name.toLocaleLowerCase('de-DE').includes(needle));
}

/** While searching, every match stays visible so a hit is not stuck behind „Mehr anzeigen“. */
export function visibleIntranetChannels(
  categories: readonly IntranetCategory[],
  query: string,
  expanded: boolean,
): { items: readonly IntranetCategory[]; collapsed: boolean; canCollapse: boolean } {
  const matched = filterIntranetChannels(categories, query);
  if (query.trim().length > 0) {
    return { items: matched, collapsed: false, canCollapse: false };
  }
  return previewItems(matched, expanded, INTRANET_CHANNEL_PREVIEW);
}
